import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { X, CheckSquare, FolderKanban, Activity, Clock, BarChart3, Zap, Calendar } from "lucide-react";

const availableWidgets = [
  { type: "stats", label: "Statistikk", icon: BarChart3, description: "Oversikt over kunder, investorer og prosjekter" },
  { type: "myTasks", label: "Mine Oppgaver", icon: CheckSquare, description: "Dine aktive oppgaver" },
  { type: "upcomingTasks", label: "Kommende Oppgaver", icon: Calendar, description: "Oppgaver neste 7 dager" },
  { type: "projects", label: "Prosjektoversikt", icon: FolderKanban, description: "Status på aktive prosjekter" },
  { type: "activities", label: "Nylige Aktiviteter", icon: Activity, description: "Siste aktiviteter i systemet" },
  { type: "timeTracking", label: "Tidsregistrering", icon: Clock, description: "Registrert tid denne uken" },
  { type: "investorHealth", label: "Investorhelse", icon: Activity, description: "Relasjonshelse-score for investorer" },
  { type: "integrations", label: "Integrasjoner", icon: Zap, description: "Tilgjengelige integrasjoner" },
];

export default function WidgetSelector({ selectedWidgets, onToggle, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-2xl max-h-[80vh] overflow-y-auto">
        <div className="p-6 border-b border-slate-100 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-slate-900">Tilpass Dashboard</h2>
          <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-lg transition-colors">
            <X className="w-5 h-5 text-slate-500" />
          </button>
        </div>
        
        <div className="p-6 space-y-3">
          <p className="text-sm text-slate-600 mb-4">Velg hvilke widgets du vil vise på dashboardet ditt</p>
          
          {availableWidgets.map((widget) => {
            const isSelected = selectedWidgets.some(w => w.type === widget.type);
            const Icon = widget.icon;
            
            return (
              <div
                key={widget.type}
                className="flex items-start gap-3 p-4 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
                onClick={() => onToggle(widget.type)}
              >
                <Checkbox checked={isSelected} className="mt-1" />
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <Icon className="w-4 h-4 text-zinc-900" />
                    <h3 className="font-medium text-slate-900">{widget.label}</h3>
                  </div>
                  <p className="text-sm text-slate-600">{widget.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="p-6 border-t border-slate-100 flex justify-end">
          <Button onClick={onClose} className="bg-slate-900 hover:bg-slate-800">
            Ferdig
          </Button>
        </div>
      </Card>
    </div>
  );
}